module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), (_vm.profile.authProfile.email_verified && _vm.shpoUserDto.roleList && _vm.shpoUserDto.roleList.length > 0) ? _c('div', {
    staticClass: "wrapper"
  }, [_c('userSignature')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "row row-wider"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "min-height": "150px"
    }
  }, [(_vm.authenticated && !_vm.hasUserRoles && _vm.shpoUserDto.otherUserAuth0Method) ? _c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [(!_vm.profile.authProfile.email_verified) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("\n                        You have not validated your account email address.\n                ")]) : _c('div', {
    staticClass: "from-group",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("Duplicate Login Found")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "line-height": "1.5"
    }
  }, [_vm._v("\n                        You have attempted to log in using "), _c('b', [_vm._v(_vm._s(_vm.authMethod))]), _vm._v(", but the email address supplied is already associated\n                        with a user in the system using the "), _c('b', [_vm._v(_vm._s(_vm.shpoUserDto.otherUserAuth0Method))]), _vm._v(".  \n\t\t\t\t\t\tPlease log out of the system, then log back in using the original method used:\n                        "), _c('br'), _c('br'), _vm._v(" "), (_vm.shpoUserDto.otherUserAuth0Method == 'google-oauth2') ? _c('div', [_vm._v("\n\t\t\t\t\t\t\tTo log in with a Google account, click the button labeled 'Sign in with Google'.\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.shpoUserDto.otherUserAuth0Method == 'auth0') ? _c('div', [_vm._v("\n\t\t\t\t\t\t\tTo log in with an Auth0 account, enter your email, password, and click the blue 'Log In' button.\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.shpoUserDto.otherUserAuth0Method == 'windowslive') ? _c('div', [_vm._v("\n\t\t\t\t\t\t\tTo log in with a Microsoft Live Account, click the button labeled 'Sign in with Microsoft'.\n\t\t\t\t\t\t")]) : _vm._e()])])]) : _c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "from-group",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [(!_vm.profile.authProfile.email_verified) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("\n                        You have not validated your account email address.\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.profile.authProfile.email_verified && !_vm.hasUserRoles) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("\n                        You user roles have not been set up yet.\n                    ")]) : _vm._e()]), _vm._v(" "), (!_vm.authenticated) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label text-label"
  }, [_vm._v("authenticated")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 text-label"
  }, [_vm._v(_vm._s(this.authenticated))])]) : _vm._e(), _vm._v(" "), (!_vm.profile.authProfile.email_verified) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label text-label"
  }, [_vm._v("email verified")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 text-label"
  }, [_vm._v(_vm._s(_vm.profile.authProfile.email_verified ? 'Verified' : 'Not Verified'))]), _vm._v(" "), (!_vm.profile.authProfile.email_verified) ? _c('div', {
    staticClass: "col-sm-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.sendVerifyEmail
    }
  }, [_vm._v("Resend Verification Email")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticStyle: {
      "margin-left": "15px",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "alert alert-dismissible",
    class: [_vm.verifyAlertHidden ? 'hidden' : '', _vm.alertType],
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeVerifyAlert()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v("\n                            " + _vm._s(_vm.verifyAlertMessage) + "\n                        ")])])]), _vm._v(" "), (_vm.authenticated && !_vm.result.isValid) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label text-label"
  }, [_vm._v("valid")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 text-label"
  }, [_vm._v(_vm._s(_vm.result.isValid))])]) : _vm._e(), _vm._v(" "), (_vm.authenticated && !_vm.result.isValid) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label text-label"
  }, [_vm._v("errors")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('ul', _vm._l((_vm.result.messageList), function(item) {
    return _c('li', {
      key: item.index
    }, [_vm._v(_vm._s(item))])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.authenticated) ? _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label text-label"
  }, [_vm._v("name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 text-label"
  }, [_vm._v(_vm._s(_vm.profile.authProfile.name))])]) : _vm._e(), _vm._v(" "), (_vm.authenticated) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label text-label"
  }, [_vm._v("email")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 text-label"
  }, [_vm._v(_vm._s(_vm.profile.authProfile.email))])]) : _vm._e(), _vm._v(" "), (_vm.authenticated) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label text-label"
  }, [_vm._v("Roles")]), _vm._v(" "), (_vm.shpoUserDto.roleList && _vm.shpoUserDto.roleList.length > 0) ? _c('div', {
    staticClass: "col-sm-8"
  }, [_c('ul', _vm._l((_vm.shpoUserDto.roleList), function(item) {
    return _c('li', {
      key: item.index
    }, [_vm._v(_vm._s(item))])
  }))]) : _vm._e(), _vm._v(" "), (!_vm.shpoUserDto.roleList || _vm.shpoUserDto.roleList.length === 0) ? _c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                        No roles assigned\n                    ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.authenticated) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label text-label"
  }, [_vm._v("Organizations")]), _vm._v(" "), (_vm.shpoUserDto.userOrganizationList && _vm.shpoUserDto.userOrganizationList.length > 0) ? _c('div', {
    staticClass: "col-sm-8"
  }, [_c('ul', _vm._l((_vm.shpoUserDto.userOrganizationList), function(item) {
    return _c('li', {
      key: item.organizationId
    }, [_vm._v(_vm._s(item.description))])
  }))]) : _vm._e(), _vm._v(" "), (!_vm.shpoUserDto.userOrganizationList || _vm.shpoUserDto.userOrganizationList.length === 0) ? _c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                        No organizations assigned\n                    ")]) : _vm._e()]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("User Information")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8bcefa08"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UserInfo.vue
// module id = 973
// module chunks = 1